/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';

import StatusLabel from '../StatusLabel';
import TasksUpListPopUp from '../../TasksUpListPopUpNew';
import TimeTargetOptionsPopUp from '../TimeTargetOptionsPopUp';
import TaskStatBlock from '../../TasksExecsLists/_items/TaskStatBlock';
import TaskGeoTargetState from '../CheckGeotargetAccess/TaskGeoTargetState';

class TaskPanelBodyAsOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTaskUpListPopUp: {
        isShow: false,
        selectedType: null
      }
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.state.showTaskUpListPopUp.isShow ? (
          <TasksUpListPopUp
            taskModel={this.props.task}
            upListFastenNow={this.props.task.upListFastenNow}
            upListMarkNow={this.props.task.upListMarkNow}
            selectedType={this.state.showTaskUpListPopUp.selectedType}
            hideTaskUpListPopUp={() => {
              this.setState({
                showTaskUpListPopUp: { isShow: false, type: null }
              });
            }}
            refreshTaskItem={() => this.props.refreshTaskItem()}
          />
        ) : null}
        <TimeTargetOptionsPopUp
          id={`timeTargetInfo-task${this.props.task.id}`}
          timeTargetTaskCurrentOptions={
            this.props.task.timeTargetCurrentOptions
          }
          timeTarget={this.props.task.timeTarget}
        />
        <div className="panel-bar">
          <ul className="nav nav-tabs">
            <li className="active">
              <a
                data-toggle="tab"
                href={`#tabOptionsTask-${this.props.task.id}`}
              >
                {t('Параметры')}
              </a>
            </li>
            <li>
              <a data-toggle="tab" href={`#tabStatistic-${this.props.task.id}`}>
                {t('Статистика')}
              </a>
            </li>
          </ul>
        </div>
        <div className="panel-body">
          <div className="tab-content">
            <div
              className="tab-pane active"
              id={`tabOptionsTask-${this.props.task.id}`}
            >
              <div className="row offset_bottom offset_bottom_xs">
                <div className="col-xs-24 col-sm-12">
                  <dl className="dl-options dl-options-sm dl-horizontal task-options-left">
                    <dt>{t('Категория')}:</dt>
                    <dd>{this.props.task.taskTypeDesc}</dd>
                    <dt>{t('Дата изменения')}:</dt>
                    <dd>
                      <span className="text-success">
                        {formatter.dateFormat3(this.props.task.updatedAt)}
                      </span>
                    </dd>
                    <dt>{t('Закрепить')}:</dt>
                    <dd>
                      <a
                        href=""
                        onClick={e => {
                          e.preventDefault();
                          this.setState({
                            showTaskUpListPopUp: {
                              isShow: true,
                              selectedType: 1
                            }
                          });
                        }}
                      >
                        {this.props.task.upListFastenNow ||
                        this.props.task.upListFastenByCategoryNow ? (
                          <React.Fragment>
                            {t(
                              '<span class="text-success">Да</span>, продлить'
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {t(
                              '<span class="text-danger">Нет</span>, включить'
                            )}
                          </React.Fragment>
                        )}
                      </a>
                    </dd>
                    <dt>{t('Выделить')}:</dt>
                    <dd>
                      <a
                        href=""
                        onClick={e => {
                          e.preventDefault();
                          this.setState({
                            showTaskUpListPopUp: {
                              isShow: true,
                              selectedType: 2
                            }
                          });
                        }}
                      >
                        {this.props.task.upListMarkNow ? (
                          <React.Fragment>
                            {t(
                              '<span class="text-success">Да</span>, продлить'
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {t(
                              '<span class="text-danger">Нет</span>, включить'
                            )}
                          </React.Fragment>
                        )}
                      </a>
                    </dd>
                    <dt>{t('Автоподнятие')}:</dt>
                    <dd>
                      <a
                        href=""
                        onClick={e => {
                          e.preventDefault();
                          this.setState({
                            showTaskUpListPopUp: {
                              isShow: true,
                              selectedType: null
                            }
                          });
                        }}
                      >
                        {this.props.task.autoLiftInterval ? (
                          <React.Fragment>
                            {t('<span class="text-success">Да</span>, раз в')}{' '}
                            {formatter.formattedMinutes(
                              this.props.task.autoLiftInterval
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {t(
                              '<span class="text-danger">Нет</span>, включить'
                            )}
                          </React.Fragment>
                        )}
                      </a>
                    </dd>
                  </dl>
                </div>
                <div className="col-xs-24 col-sm-12">
                  <dl className="dl-options dl-options-sm dl-horizontal task-options-right">
                    <dt>{t('Статус')}:</dt>
                    <dd>
                      <StatusLabel status={this.props.task.status} />
                    </dd>
                    <dt>{t('Цена выполнения')}:</dt>
                    <dd>{this.props.task.totalCostExecution} ₽</dd>
                    <dt>{t('Кол. выполнений')}:</dt>
                    <dd>
                      {t('{current} из {from}', {
                        current: this.props.task.statFinishedExecs,
                        from: this.props.task.maxExecutions
                      })}
                    </dd>
                    <dt
                      title={
                        this.props.task.tasksExecsStat.free_executions_slots
                          .desc
                      }
                    >
                      {
                        this.props.task.tasksExecsStat.free_executions_slots
                          .desc
                      }
                      :
                    </dt>
                    <dd>
                      {
                        this.props.task.tasksExecsStat.free_executions_slots
                          .count
                      }
                    </dd>
                    <dt title="Таргетинг по времени">
                      {t('Таргетинг по времени')}:
                    </dt>
                    <dd>
                      {this.props.task.timeTarget &&
                      this.props.task.timeTarget.length > 0 ? (
                        <a
                          data-toggle="modal"
                          href={`#timeTargetInfo-task${this.props.task.id}`}
                        >
                          {t('<span class="text-success">Есть</span>, узнать')}
                        </a>
                      ) : (
                        <React.Fragment>{t('Нет')}</React.Fragment>
                      )}
                    </dd>
                    <dt title="Геотаргетинг">{t('Геотаргетинг')}:</dt>
                    <dd>
                      <TaskGeoTargetState task={this.props.task} />
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div className="tab-pane" id={`tabStatistic-${this.props.task.id}`}>
              <TaskStatBlock
                taskId={this.props.task.id}
                tasksExecsStat={this.props.task.tasksExecsStat}
              />
            </div>
          </div>
          {[5, 7].includes(this.props.task.status) && this.props.task.lock ? (
            <div className="row offset_bottom offset_bottom_xs">
              <div
                className="alert alert-danger m-b-15 m-t-20 text-center"
                role="alert"
              >
                <p className="alert-heading">
                  <strong>{this.props.task.lock.reasonText}</strong>
                </p>
                <p>{this.props.task.lock.comment}</p>
              </div>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

TaskPanelBodyAsOwner.defaultProps = {
  refreshTaskItem: () => {}
};

TaskPanelBodyAsOwner.propTypes = {
  refreshTaskItem: PropTypes.func,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    taskTypeDesc: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    totalCostExecution: PropTypes.string.isRequired,
    statFinishedExecs: PropTypes.number.isRequired,
    free_exec_slots: PropTypes.number.isRequired,
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired,
      free_executions_slots: PropTypes.shape({
        desc: PropTypes.string,
        count: PropTypes.number
      }).isRequired
    }).isRequired,
    maxExecutions: PropTypes.number.isRequired,
    timeTarget: PropTypes.arrayOf(PropTypes.shape).isRequired,
    timeTargetCurrentOptions: PropTypes.shape({}).isRequired,
    hasGeoTarget: PropTypes.bool.isRequired,
    lock: PropTypes.shape({
      reasonText: PropTypes.string.isRequired,
      comment: PropTypes.string.isRequired
    }),
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    upListFastenByCategoryNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    autoLiftInterval: PropTypes.number.isRequired,
    updatedAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TaskPanelBodyAsOwner);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelBodyAsOwner/TaskPanelBodyAsOwner.js